import React from 'react';

export default function FixPrice() {
  return (
    <div className="container my-5">
      <div className="card shadow-lg rounded-4">
        <div className="card-body p-5">
          <div className="text-center mb-4">
            <h1 className="h3 fw-bold text-dark">eCommerce Web App Quote</h1>
            <p className="text-muted">One-off development cost</p>
            <div className="my-3">
              <span className="badge bg-success fs-5 px-4 py-2">£3,500</span>
            </div>
            <p className="text-secondary small">Delivery: 3–6 weeks</p>
          </div>



<div class="table-responsive">
  <table class="table table-bordered table-striped align-middle">
    <thead class="table-light">
      <tr>
        <th scope="col width: 260px;">Category</th>
        <th scope="col">Feature</th>
      </tr>
    </thead>
    <tbody>
 
      <tr>
        <td rowspan="12">🔒 <strong>User &amp; Customer Features</strong></td>
        <td>✅ User Authentication (sign-up, login, password reset)</td>
      </tr>
      <tr><td>✅ Customer Dashboard (order history, profile management)</td></tr>
      <tr><td>✅ Cart system with session/local storage handling</td></tr>
      <tr><td>✅ Stripe integration (with webhook support for auto-confirming orders)</td></tr>
      <tr><td>✅ Email notifications (e.g., order confirmation, password reset)</td></tr>
      <tr><td>✅ Mobile-first, responsive design</td></tr>
      <tr><td>✅ Custom-branded frontend (no off-the-shelf templates)</td></tr>
      <tr><td>✅ Real-time stock status on product pages</td></tr>
      <tr><td>✅ Search bar with keyword and category filtering</td></tr>
      <tr><td>✅ Guest checkout option (no account required)</td></tr>
      <tr><td>✅ Auto-calculate shipping and VAT based on postcode</td></tr>
      <tr><td>✅ GDPR-compliant privacy and data handling</td></tr>



  <tr>
    <td rowspan="11">🛒 <strong>Admin &amp; Product Management</strong></td>
    <td>✅ Admin dashboard with login authentication</td>
  </tr>
  <tr><td>✅ Product management (CRUD: create, read, update, delete)</td></tr>
  <tr><td>✅ Order management (view orders, change status)</td></tr>
  <tr><td>✅ Inventory tracking</td></tr>
  <tr><td>✅ Product categories</td></tr>
  <tr><td>✅ Basic sales analytics (e.g., number of orders, revenue summary)</td></tr>
  <tr><td>✅ Add discount codes or sales events</td></tr>
  <tr><td>✅ Admin role management (e.g., super admin, editor)</td></tr>
  <tr><td>✅ CSV import/export for bulk product uploads</td></tr>
  <tr><td>✅ Set shipping rate rules by postcode or region</td></tr>
  <tr><td>✅ Approve, refund, or cancel orders directly</td></tr>


  <tr>
    <td rowspan="7">🔧 <strong>Technical Stack &amp; Deployment</strong></td>
    <td>✅ Frontend and backend separation (e.g., React + Node.js/Express or Django REST)</td>
  </tr>
  <tr><td>✅ Secure API endpoints</td></tr>
  <tr><td>✅ HTTPS/SSL with custom domain setup</td></tr>
  <tr><td>✅ Deployed on scalable cloud infrastructure (e.g., Vercel, DigitalOcean, AWS)</td></tr>
  <tr><td>✅ Database setup (MongoDB/PostgreSQL)</td></tr>
  <tr><td>✅ Git-based version control and CI/CD setup</td></tr>
  <tr><td>✅ API documentation using Swagger or Postman</td></tr>
</tbody>


  </table>
</div>




          <section className="mb-4">
            <h2 className="h5 fw-bold text-primary border-bottom pb-2">🔒 User & Customer Features</h2>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ User Authentication (sign-up, login, password reset)</li>
              <li className="list-group-item">✅ Customer Dashboard (order history, profile management)</li>
              <li className="list-group-item">✅ Cart system with session/local storage handling</li>
              <li className="list-group-item">✅ Stripe integration (with webhook support for auto-confirming orders)</li>
              <li className="list-group-item">✅ Email notifications (e.g., order confirmation, password reset)</li>
              <li className="list-group-item">✅ Mobile-first, responsive design</li>
              <li className="list-group-item">✅ Custom-branded frontend (no off-the-shelf templates)</li>
             
   
              <li className="list-group-item">✅ Real-time stock status on product pages</li>
              <li className="list-group-item">✅ Search bar with keyword and category filtering</li>
              <li className="list-group-item">✅ Guest checkout option (no account required)</li>
              <li className="list-group-item">✅ Auto-calculate shipping and VAT based on postcode</li>
              <li className="list-group-item">✅ GDPR-compliant privacy and data handling</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h5 fw-bold text-primary border-bottom pb-2">🛒 Admin & Product Management</h2>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Admin dashboard with login authentication</li>
              <li className="list-group-item">✅ Product management (CRUD: create, read, update, delete)</li>
              <li className="list-group-item">✅ Order management (view orders, change status)</li>
              <li className="list-group-item">✅ Inventory tracking</li>
              <li className="list-group-item">✅ Product categories</li>
              <li className="list-group-item">✅ Basic sales analytics (e.g., number of orders, revenue summary)</li>
   
              <li className="list-group-item">✅ Add discount codes or sales events</li>
              <li className="list-group-item">✅ Admin role management (e.g., super admin, editor)</li>
              <li className="list-group-item">✅ CSV import/export for bulk product uploads</li>
              <li className="list-group-item">✅ Set shipping rate rules by postcode or region</li>
              <li className="list-group-item">✅ Approve, refund, or cancel orders directly</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h5 fw-bold text-primary border-bottom pb-2">🔧 Technical Stack & Deployment</h2>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Frontend and backend separation (e.g., React + Node.js/Express or Django REST)</li>
              <li className="list-group-item">✅ Secure API endpoints</li>
              <li className="list-group-item">✅ HTTPS/SSL with custom domain setup</li>
              <li className="list-group-item">✅ Deployed on scalable cloud infrastructure (e.g., Vercel, DigitalOcean, AWS)</li>
              <li className="list-group-item">✅ Database setup (MongoDB/PostgreSQL)</li>
              <li className="list-group-item">✅ Git-based version control and CI/CD setup</li>
              <li className="list-group-item">✅ API documentation using Swagger or Postman</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h5 fw-bold text-primary border-bottom pb-2">📄 Final Touches</h2>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Setup documentation / deployment guide</li>
              <li className="list-group-item">✅ Handover session (optional Zoom training for admin)</li>
              <li className="list-group-item">✅ 30 days of post-launch bug support</li>
            </ul>
          </section>
          <section className="mb-4">
            <h2 className="h5 fw-bold text-primary border-bottom pb-2">
              💳 Easy Monthly Payment Options (0% Interest)
            </h2>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Plan Duration</th>
                  <th>Monthly Payment</th>
                  <th>0% Interest</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>6 months</td>
                  <td>£583.33</td>
                  <td>✅ Yes</td>
                </tr>
                <tr>
                  <td>12 months</td>
                  <td>£291.67</td>
                  <td>✅ Yes</td>
                </tr>
              </tbody>
            </table>
          </section>


          <section className="mb-4">
            <h2 className="h5 fw-bold text-primary border-bottom pb-2">📌 Why £3,500 is a Smart Investment for You</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Category</th>
                  <th scope="col">Reason</th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td>Security & quality</td>
                  <td>Secure APIs, webhooks, HTTPS, clean code</td>
                </tr>
                <tr>
                  <td>Business readiness</td>
                  <td>Stripe-ready, branded, email-ready, customer dashboard</td>
                </tr>
                <tr>
                  <td>Scalability & handover</td>
                  <td>Clean architecture, docs, deployable codebase</td>
                </tr>
                <tr>
                  <td>Long-term use</td>
                  <td>Designed to last and grow with the business</td>
                </tr>
              </tbody>
            </table>
          </section>

         
        </div>
      </div>
    </div>
  );
}


